// Reducer for UI modals
import {
  SHOW_LOGIN_MODAL,
  HIDE_LOGIN_MODAL,
  SHOW_SIGNUP_MODAL,
  HIDE_SIGNUP_MODAL
} from './actions';

const initialState = {
  showLogin: false,
  showSignup: false,
};

export default function uiModalsReducer(state = initialState, action) {
  switch (action.type) {
    case SHOW_LOGIN_MODAL:
      return { ...state, showLogin: true };
    case HIDE_LOGIN_MODAL:
      return { ...state, showLogin: false };
    case SHOW_SIGNUP_MODAL:
      return { ...state, showSignup: true };
    case HIDE_SIGNUP_MODAL:
      return { ...state, showSignup: false };
    default:
      return state;
  }
}
